/**
 * Extrai texto legível de um erro de requisição.
 *
 * A API não tem um formato único de erro: o corpo pode ser uma string JSON
 * (login e vários endpoints antigos), um objeto com `message` (as regras de
 * negócio) ou um objeto com `errors` (validação do FormRequest). Passar o
 * corpo cru ao toast do projeto renderiza "[object Object]" quando o formato
 * não é o esperado, e passar uma string fixa engole a mensagem que o servidor
 * mandou — que é justamente a que diz ao operador o que fazer.
 */
export default {
  methods: {
    /**
     * @param {*} error   erro capturado (axios ou exceção)
     * @param {string} [fallback] usado quando o servidor não mandou mensagem
     * @returns {string}
     */
    apiErrorText(error, fallback = 'Falha inesperada na requisição.') {
      const data = error && error.response ? error.response.data : null;

      if (typeof data === 'string' && data.trim()) return data;

      if (data && typeof data === 'object') {
        if (typeof data.message === 'string' && data.message) {
          return data.message;
        }

        if (data.errors && typeof data.errors === 'object') {
          const first = Object.values(data.errors)[0];
          if (Array.isArray(first) && first.length) return first[0];
          if (typeof first === 'string') return first;
        }

        // Validação do BaseController devolve { campo: ["mensagem"] } sem
        // envelope `errors`.
        const first = Object.values(data)[0];
        if (Array.isArray(first) && first.length && typeof first[0] === 'string') {
          return first[0];
        }
      }

      return fallback;
    },
  },
};
